// @ts-check

/** A customer's body measurements for a made-to-order piece: the same eight fields, in inches, as the garment measurements. */
export const MEASUREMENT_FIELDS = [
  { key: 'bust', label: 'Bust' },
  { key: 'upper_bust', label: 'Upper bust' },
  { key: 'waist', label: 'Waist' },
  { key: 'hip', label: 'Hip' },
  { key: 'shoulder', label: 'Shoulder' },
  { key: 'length', label: 'Length' },
  { key: 'sleeve', label: 'Sleeve' },
  { key: 'inseam', label: 'Inseam' },
];

export const MAX_INCHES = 120;

const text = (value) => String(value ?? '').trim();

/**
 * The numbers that were filled in, or null when nothing was measured. Typed text in, numbers out.
 * @param {Record<string, string | number | null | undefined> | undefined} values
 * @returns {Record<string, number> | null}
 */
export function cleanMeasurements(values) {
  /** @type {Record<string, number>} */
  const cleaned = {};
  for (const { key } of MEASUREMENT_FIELDS) {
    const typed = text(values?.[key]);
    if (typed === '') continue;
    const number = Number(typed);
    if (Number.isFinite(number)) cleaned[key] = number;
  }
  return Object.keys(cleaned).length > 0 ? cleaned : null;
}

/** First bad entry, or null. Blank is fine; anything typed must be a number above 0 and at most 120 inches. */
export function validateMeasurements(values) {
  for (const { key, label } of MEASUREMENT_FIELDS) {
    const typed = text(values?.[key]);
    if (typed === '') continue;
    const number = Number(typed);
    if (!(number > 0 && number <= MAX_INCHES)) return `${label} must be a number between 0 and ${MAX_INCHES} inches`;
  }
  return null;
}

/** True when a piece has any measurement or a fit note entered. */
export const hasMeasurements = (line) => cleanMeasurements(line?.measurements) !== null || text(line?.fitNotes) !== '';
